require('../../modules/es6.object.is');
module.exports = require('../../modules/_core').Object.is;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/fn/object/is.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/fn/object/is.js
// module chunks = 6